import { FunctionComponent, ReactNode, Suspense } from "react";

import { AppRole } from "../../../../@api";

import { LazyRoleCheckGuard } from "../Guards/LazyGuards";

/**
 * Factory function that creates a lazy-loaded RoleCheckGuard with a specific role.
 * Use this in the guards array of lazyRouteWithGuards.
 *
 * @example
 * lazy: lazyRouteWithGuards({
 *   importer: () => import("./YourPage"),
 *   componentName: "YourPage",
 *   guards: [createLazyRoleCheckGuard(AppRole.SummarizationFeature)],
 * })
 */
export const createLazyRoleCheckGuard = (role: AppRole): FunctionComponent<{ children: ReactNode }> => {
  const Guard: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
    <Suspense fallback={null}>
      <LazyRoleCheckGuard role={role}>{children}</LazyRoleCheckGuard>
    </Suspense>
  );

  return Guard;
};
